import { Column } from 'primereact/column'

const BaseTableColumn = Column

export default BaseTableColumn